import { requireAuth } from '@/router/helpers';

export default [
  {
    path: '/styleguide',
    name: 'Styleguide',
    component: () => import('@/views/Styleguide'),
    beforeEnter: requireAuth,
  },
  {
    path: '/content/:pageSlug(.*)/documents/:docType/:id',
    name: 'ContentPageWithParentAllSlidout',
    components: {
      default: () => import('@/views/content/Page'),
      panel: () => import('@/views/documents/DocumentPreview'),
    },
    beforeEnter: requireAuth,
    meta: { isAdmin: false, openPanel: true },
  },
  {
    path: '/content/:pageSlug(.*)',
    name: 'ContentPageWithParentAll',
    component: () => import('@/views/content/Page'),
    beforeEnter: requireAuth,
    meta: { isAdmin: false },
  },
];
